import React from 'react';

import MuiTextField from '@mui/material/TextField';

const TextField = React.forwardRef((props, ref) => {
  return <MuiTextField ref={ref} size="small" margin="dense" {...props} />;
});
TextField.displayName = 'TextField';
export default TextField;
